import { Building } from "../Building";
import { BuildingGeometry } from "../BuildingGeometry";
import { RoofSide } from "./RoofSide";
import { THREEUtils } from "../../utils/THREEUtils";
import { Vector2, Object3D } from "three";

export class Roof
{

	private _building : Building;

	private _left     : RoofSide;
	private _right    : RoofSide;

	constructor(building:Building)
	{
		this._building = building;
		this.init();
	}

	private init()
	{
		var roofSideConfig = {
			building: this._building,
			external_geometry: BuildingGeometry.createRoofGeometry(),
			internal_geometry: BuildingGeometry.createRoofGeometry(),
			overhang_geometry: BuildingGeometry.createRoofGeometry(),
			overhang_end_geometry: BuildingGeometry.createRoofGeometry()
		};

		this._left  = new RoofSide(roofSideConfig);
		this._right = new RoofSide(roofSideConfig);
	}

	public add(parent:Object3D)
	{
		this._left.add(parent);
		this._right.add(parent);
	}

	public update()
	{
		var metrics = this._building.config.metrics;
		var length = metrics.length;
		var alpha = metrics.alpha;
		var roofPosY = metrics.top + 0.001; // add some offset so walls don't overlap roof

		var pitched_overhang_left  = metrics.overhang_left / Math.cos(alpha);
		var pitched_overhang_right = metrics.overhang_right / Math.cos(alpha);

		var scale_length = length + metrics.overhang_front + metrics.overhang_back;
		var scale_width_left = (metrics.width_half + metrics.overhang_left) / Math.cos(alpha);
		var scale_width_right = (metrics.width_half + metrics.overhang_right) / Math.cos(alpha);

		var leftAlpha = alpha;
		var rightAlpha = alpha;

		var single_slope = this._building.config.building.single_slope.value;

		//if (single_slope === "left")
		//{
		//	leftAlpha *= -1;
		//} else
		if (single_slope)
		{
			rightAlpha *= -1;
		}

		this._left.container.position.y = roofPosY;
		this._left.container.position.z = (metrics.overhang_front - metrics.overhang_back) / 2;
		this._left.container.rotation.z = Math.PI / 2 + leftAlpha;
		this._left.update(scale_length, scale_width_left);

		this._right.container.position.y = roofPosY;
		this._right.container.position.z = (metrics.overhang_front - metrics.overhang_back) / 2;
		this._right.container.rotation.y = Math.PI;
		this._right.container.rotation.z = Math.PI / 2 + rightAlpha;
		this._right.update(scale_length, scale_width_right);

		THREEUtils.scaleUVs(this._left.config.external_geometry, new Vector2(scale_length, scale_width_left));
		THREEUtils.scaleUVs(this._left.config.internal_geometry, new Vector2(scale_length, scale_width_left - pitched_overhang_left));
		THREEUtils.scaleUVs(this._left.config.overhang_geometry, new Vector2(scale_length, pitched_overhang_left));
		THREEUtils.scaleUVs(this._left.config.overhang_end_geometry, new Vector2((metrics.overhang_front + metrics.overhang_back) / 2, scale_width_left - pitched_overhang_left));


		//this._right.scale(scale_x, scale_y);

		/*

		var roof_side_scale_x = length + metrics.overhang_end * 2;
		var roof_side_scale_y = (width_half + metrics.overhang_sides) / Math.cos(alpha);

		var roofPosY = metrics.top + 0.001; // add some offset so walls don't overlap roof

		roof_left.scale.z = roof_side_scale_x;
		roof_left.scale.y = roof_side_scale_y;
		roof_left.position.y = roofPosY;
		roof_left.rotation.z = Math.PI / 2 + alpha;

		roof_right.scale.z = roof_side_scale_x;
		roof_right.scale.y = roof_side_scale_y;
		roof_right.position.y = roofPosY;
		roof_right.rotation.z = Math.PI / 2 + alpha;
		roof_right.rotation.y = Math.PI;

		THREEUtils.scaleUVs(roof_left.geometry, new Vector2(roof_side_scale_x, roof_side_scale_y));
		*/
	}
}